/* eslint-disable react/prop-types */
import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import { FormControl, FormControlLabel, FormHelperText, FormLabel, Grid, InputAdornment, MenuItem, OutlinedInput, Radio, RadioGroup, Rating, Select, TextField } from '@mui/material';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Typography from '@mui/material/Typography';
import ClearIcon from "@mui/icons-material/Clear";
import { useFormik } from 'formik';
import * as yup from "yup";
import { toast } from 'react-toastify';
import { useState, useEffect } from 'react';
import { apiget, apipost } from '../../service/api';
import Palette from '../../theme/palette';

const Add = (props) => {
  const { open, handleClose, _id, setUserAction } = props;
  const [user, setUser] = useState([]);

  const userid = localStorage.getItem('user_id');
  const userdata = JSON.parse(localStorage.getItem('user'));

  // -----------  validationSchema
  const validationSchema = yup.object({
    title: yup.string().required("Title is required"),
    firstName: yup.string().required("First Name is required"),
    lastName: yup.string().required("Last Name is required"),
    dateOfBirth: yup.date().required("Date of Birth is required"),
    phoneNumber: yup.string().matches(/^[0-9]{10}$/, 'Phone number is invalid').required('Phone number is required'),
    emailAddress: yup.string().email('Invalid email').required("Email is required"),
    address: yup.string().required("Address is required"),
    assigned_agent: yup.string().required("Assigned Agent is required")
  });

  // -----------   initialValues
  const initialValues = {
    title: "",
    firstName: "",
    lastName: "",
    dateOfBirth: "",
    gender: "",
    phoneNumber: "",
    emailAddress: "",
    address: "",
    loanSource: "0",
    loanStatus: "",
    loanScore: "",
    alternatePhoneNumber: "",
    additionalEmailAddress: "",
    instagramProfile: "",
    twitterProfile: "",
    typeOfInsurance: "",
    desiredCoverageAmount: "",
    specificPolicyFeatures: "",
    QualificationStatus: "",
    policyType: "",
    policyNumber: "",
    startDate: "",
    endDate: "",
    coverageAmount: "",
    termLength: "",
    conversionReason: "",
    conversionDateTime: "",
    loanCategory: "",
    loanPriority: "",
    assigned_agent: "",
    createdBy: userid,
    contact_id: _id,
    // New fields
    salesAgentCode: "",
    agentName: "",
    agentPhone: "",
    loanOfficer: "",
    subjectAddress: "",
    subjectPropertyZip: "",
    community: "",
    lotNumber: "",
    priceChange: "",
    completionDate: "",
    incentiveMax: "",
    solar: "",
    hoa1: "",
    hoa2: "",
    homeToSell: "",
    realtorContact: "",
    helpfulInfo: "",
    leadAssignedTo: "",
    lassoRecordNumber: "",
    contactDate1: "",
    contactType1: "",
    contactResults1: "",
    contactDate2: "",
    contactType2: "",
    contactResults2: "",
    contactDate3: "",
    contactType3: "",
    contactResults3: "",
    preApproved: "",
    refiOfferAccepted: "",
    assignCampaign: "",
    campaignLastSentDate: "",
    optIn: "",
    subscribed: ""
  };

  // add Loan api
  const addLoan = async (values) => {
    const data = values;
    const result = await apipost('lead/add', data);
    setUserAction(result);

    if (result && result.status === 201) {
      formik.resetForm();
      handleClose();
      toast.success(result.data.message);
    }
  }

  // formik
  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: async (values) => {
      addLoan(values);
    },
  });

  // user api
  const fetchUserData = async () => {
    const result = await apiget('user/list');
    if (result && result.status === 200) {
      setUser(result?.data?.result);
    }
  }

  useEffect(() => {
    fetchUserData();
  }, []);

  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
      >
        <DialogTitle
          id="scroll-dialog-title"
          style={{
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <Typography variant="h6">Add New</Typography>
          <Typography>
            <ClearIcon
              onClick={handleClose}
              style={{ cursor: "pointer" }}
            />
          </Typography>
        </DialogTitle>
        <DialogContent dividers>
          <form>
            <DialogContentText
              id="scroll-dialog-description"
              tabIndex={-1}
            >
              <Typography style={{ marginBottom: "15px" }} variant="h6">
                Basic Information
              </Typography>
              <Grid container rowSpacing={3} columnSpacing={{ xs: 0, sm: 5, md: 4 }}>
                <Grid item xs={12} sm={4} md={4}>
                  <FormControl fullWidth>
                    <FormLabel>Title</FormLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="title"
                      name="title"
                      label=""
                      size='small'
                      fullWidth
                      value={formik.values.title || null}
                      onChange={formik.handleChange}
                      error={formik.touched.title && Boolean(formik.errors.title)}
                      helperText={formik.touched.title && formik.errors.title}
                    >
                      <MenuItem value="Mr.">Mr.</MenuItem>
                      <MenuItem value="Mrs.">Mrs. </MenuItem>
                      <MenuItem value="Miss.">Miss. </MenuItem>
                      <MenuItem value="Ms.">Ms. </MenuItem>
                      <MenuItem value="Dr.">Dr. </MenuItem>
                    </Select>
                    <FormHelperText style={{ color: Palette.error.main }}>{formik.touched.title && formik.errors.title}</FormHelperText>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={4} md={4}>
                  <FormLabel>First name</FormLabel>
                  <TextField
                    id="firstName"
                    name="firstName"
                    label=""
                    size='small'
                    maxRows={10}
                    fullWidth
                    value={formik.values.firstName}
                    onChange={formik.handleChange}
                    error={formik.touched.firstName && Boolean(formik.errors.firstName)}
                    helperText={formik.touched.firstName && formik.errors.firstName}
                  />
                </Grid>
                <Grid item xs={12} sm={4} md={4}>
                  <FormLabel>Last name</FormLabel>
                  <TextField
                    id="lastName"
                    name="lastName"
                    label=""
                    size='small'
                    fullWidth
                    value={formik.values.lastName}
                    onChange={formik.handleChange}
                    error={formik.touched.lastName && Boolean(formik.errors.lastName)}
                    helperText={formik.touched.lastName && formik.errors.lastName}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={6}>
                  <FormLabel>Date Of Birth</FormLabel>
                  <TextField
                    name='dateOfBirth'
                    type='date'
                    size='small'
                    fullWidth
                    value={formik.values.dateOfBirth}
                    onChange={formik.handleChange}
                    error={formik.touched.dateOfBirth && Boolean(formik.errors.dateOfBirth)}
                    helperText={formik.touched.dateOfBirth && formik.errors.dateOfBirth}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={6}>
                  <FormLabel>Phone number</FormLabel>
                  <TextField
                    id="phoneNumber"
                    name="phoneNumber"
                    type='number'
                    size='small'
                    fullWidth
                    value={formik.values.phoneNumber}
                    onChange={formik.handleChange}
                    error={formik.touched.phoneNumber && Boolean(formik.errors.phoneNumber)}
                    helperText={formik.touched.phoneNumber && formik.errors.phoneNumber}
                  />
                </Grid>
                <Grid item xs={12}>
                  <FormLabel>Email</FormLabel>
                  <TextField
                    id="emailAddress"
                    name="emailAddress"
                    label=""
                    size='small'
                    fullWidth
                    value={formik.values.emailAddress}
                    onChange={formik.handleChange}
                    error={formik.touched.emailAddress && Boolean(formik.errors.emailAddress)}
                    helperText={formik.touched.emailAddress && formik.errors.emailAddress}
                  />
                </Grid>
                
                <Grid item xs={12} sm={12} md={12}>
                  <FormLabel>Address</FormLabel>
                  <TextField
                    id="address"
                    name="address"
                    label=""
                    size='small'
                    multiline
                    rows={5}
                    fullWidth
                    value={formik.values.address}
                    onChange={formik.handleChange}
                    error={formik.touched.address && Boolean(formik.errors.address)}
                    helperText={formik.touched.address && formik.errors.address}
                  />
                </Grid>
              </Grid>

              <Typography style={{ marginBottom: "15px", marginTop: "15px" }} variant="h6">
                Source Information
              </Typography>
             

              <Typography style={{ marginBottom: "15px", marginTop: "15px" }} variant="h6">
                Loan Details
              </Typography>
              <Grid container rowSpacing={3} columnSpacing={{ xs: 0, sm: 5, md: 4 }}>
                <Grid item xs={12} sm={4} md={4}>
                  <FormControl fullWidth>
                    <FormLabel>Loan Status</FormLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="loanStatus"
                      name="loanStatus"
                      label=""
                      size='small'
                      fullWidth
                      value={formik.values.loanStatus}
                      onChange={formik.handleChange}
                    >
                      <MenuItem value="New">New</MenuItem>
                      <MenuItem value="Contacted">Contacted </MenuItem>
                      <MenuItem value="Qualified">Qualified </MenuItem>
                      <MenuItem value="Not Qualified">Not Qualified </MenuItem>
                      <MenuItem value="In Progress">In Progress</MenuItem>
                      <MenuItem value="Closed/Won">Closed/Won</MenuItem>
                      <MenuItem value="Closed/Lost">Closed/Lost </MenuItem>
                      <MenuItem value="Follow-up Required">Follow-up Required</MenuItem>
                      <MenuItem value="On Hold">On Hold</MenuItem>
                      <MenuItem value="Converted">Converted</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={4} md={4}>
                  <FormControl fullWidth>
                    <FormLabel>Assigned Agent</FormLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="assigned_agent"
                      name="assigned_agent"
                      label=""
                      size='small'
                      fullWidth
                      value={formik.values.assigned_agent}
                      onChange={formik.handleChange}
                      error={formik.touched.assigned_agent && Boolean(formik.errors.assigned_agent)}
                      helperText={formik.touched.assigned_agent && formik.errors.assigned_agent}
                    >
                      {user.map((user) => (
                        <MenuItem key={user._id} value={user._id}>
                          {`${user.firstName} ${user.lastName}`}
                        </MenuItem>
                      ))}
                    </Select>
                    <FormHelperText style={{ color: Palette.error.main }}>{formik.touched.assigned_agent && formik.errors.assigned_agent}</FormHelperText>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={4} md={4}>
                  <FormControl fullWidth>
                    <FormLabel>Loan score or rating</FormLabel>
                    <Typography display="flex">
                      <Rating name="loanScore" precision={0.1} onChange={(event, newValue) => formik.setFieldValue("loanScore", newValue)} />
                    </Typography>
                  </FormControl>
                </Grid>
              </Grid>

              {/* New fields */}
              <Typography style={{ marginBottom: "15px", marginTop: "15px" }} variant="h6">
                Additional Information
              </Typography>
              <Grid container rowSpacing={3} columnSpacing={{ xs: 0, sm: 5, md: 4 }}>
                <Grid item xs={12} sm={4} md={4}>
                  <FormLabel>Sales Agent Code</FormLabel>
                  <TextField
                    id="salesAgentCode"
                    name="salesAgentCode"
                    label=""
                    size='small'
                    fullWidth
                    value={formik.values.salesAgentCode}
                    onChange={formik.handleChange}
                  />
                </Grid>
                <Grid item xs={12} sm={4} md={4}>
                  <FormLabel>Agent Name</FormLabel>
                  <TextField
                    id="agentName"
                    name="agentName"
                    label=""
                    size='small'
                    fullWidth
                    value={formik.values.agentName}
                    onChange={formik.handleChange}
                  />
                </Grid>
                <Grid item xs={12} sm={4} md={4}>
                  <FormLabel>Agent Phone</FormLabel>
                  <TextField
                    id="agentPhone"
                    name="agentPhone"
                    label=""
                    size='small'
                    fullWidth
                    value={formik.values.agentPhone}
                    onChange={formik.handleChange}
                  />
                </Grid>
                <Grid item xs={12} sm={4} md={4}>
                  <FormLabel>Loan Officer</FormLabel>
                  <TextField
                    id="loanOfficer"
                    name="loanOfficer"
                    label=""
                    size='small'
                    fullWidth
                    value={formik.values.loanOfficer}
                    onChange={formik.handleChange}
                  />
                </Grid>
                <Grid item xs={12} sm={4} md={4}>
                  <FormLabel>Subject Address</FormLabel>
                  <TextField
                    id="subjectAddress"
                    name="subjectAddress"
                    label=""
                    size='small'
                    fullWidth
                    value={formik.values.subjectAddress}
                    onChange={formik.handleChange}
                  />
                </Grid>
                <Grid item xs={12} sm={4} md={4}>
                  <FormLabel>Subject Property Zip</FormLabel>
                  <TextField
                    id="subjectPropertyZip"
                    name="subjectPropertyZip"
                    label=""
                    size='small'
                    fullWidth
                    value={formik.values.subjectPropertyZip}
                    onChange={formik.handleChange}
                  />
                </Grid>
                <Grid item xs={12} sm={4} md={4}>
                  <FormLabel>Community</FormLabel>
                  <TextField
                    id="community"
                    name="community"
                    label=""
                    size='small'
                    fullWidth
                    value={formik.values.community}
                    onChange={formik.handleChange}
                  />
                </Grid>
                <Grid item xs={12} sm={4} md={4}>
                  <FormLabel>LOT #</FormLabel>
                  <TextField
                    id="lotNumber"
                    name="lotNumber"
                    label=""
                    size='small'
                    fullWidth
                    value={formik.values.lotNumber}
                    onChange={formik.handleChange}
                  />
                </Grid>
                <Grid item xs={12} sm={4} md={4}>
                  <FormLabel>Will the price change?</FormLabel>
                  <TextField
                    id="priceChange"
                    name="priceChange"
                    label=""
                    size='small'
                    fullWidth
                    value={formik.values.priceChange}
                    onChange={formik.handleChange}
                  />
                </Grid>
                <Grid item xs={12} sm={4} md={4}>
                  <FormLabel>Est Completion Date</FormLabel>
                  <TextField
                    id="completionDate"
                    name="completionDate"
                    type='date'
                    size='small'
                    fullWidth
                    value={formik.values.completionDate}
                    onChange={formik.handleChange}
                  />
                </Grid>
                <Grid item xs={12} sm={4} md={4}>
                  <FormLabel>Incentive Max Available</FormLabel>
                  <TextField
                    id="incentiveMax"
                    name="incentiveMax"
                    label=""
                    size='small'
                    fullWidth
                    value={formik.values.incentiveMax}
                    onChange={formik.handleChange}
                  />
                </Grid>
                <Grid item xs={12} sm={4} md={4}>
                  <FormLabel>Solar?</FormLabel>
                  <TextField
                    id="solar"
                    name="solar"
                    label=""
                    size='small'
                    fullWidth
                    value={formik.values.solar}
                    onChange={formik.handleChange}
                  />
                </Grid>
                <Grid item xs={12} sm={4} md={4}>
                  <FormLabel>HOA 1</FormLabel>
                  <TextField
                    id="hoa1"
                    name="hoa1"
                    label=""
                    size='small'
                    fullWidth
                    value={formik.values.hoa1}
                    onChange={formik.handleChange}
                  />
                </Grid>
                <Grid item xs={12} sm={4} md={4}>
                  <FormLabel>HOA 2</FormLabel>
                  <TextField
                    id="hoa2"
                    name="hoa2"
                    label=""
                    size='small'
                    fullWidth
                    value={formik.values.hoa2}
                    onChange={formik.handleChange}
                  />
                </Grid>
                <Grid item xs={12} sm={4} md={4}>
                  <FormLabel>Home to Sell?</FormLabel>
                  <TextField
                    id="homeToSell"
                    name="homeToSell"
                    label=""
                    size='small'
                    fullWidth
                    value={formik.values.homeToSell}
                    onChange={formik.handleChange}
                  />
                </Grid>
                <Grid item xs={12} sm={4} md={4}>
                  <FormLabel>Realtor Contact</FormLabel>
                  <TextField
                    id="realtorContact"
                    name="realtorContact"
                    label=""
                    size='small'
                    fullWidth
                    value={formik.values.realtorContact}
                    onChange={formik.handleChange}
                  />
                </Grid>
                <Grid item xs={12} sm={4} md={4}>
                  <FormLabel>Lead Assigned To</FormLabel>
                  <TextField
                    id="leadAssignedTo"
                    name="leadAssignedTo"
                    label=""
                    size='small'
                    fullWidth
                    value={formik.values.leadAssignedTo}
                    onChange={formik.handleChange}
                  />
                </Grid>
                <Grid item xs={12} sm={4} md={4}>
                  <FormLabel>LASSO Record #</FormLabel>
                  <TextField
                    id="lassoRecordNumber"
                    name="lassoRecordNumber"
                    label=""
                    size='small'
                    fullWidth
                    value={formik.values.lassoRecordNumber}
                    onChange={formik.handleChange}
                  />
                </Grid>
                <Grid item xs={12} sm={4} md={4}>
                  <FormLabel>Contact Date 1</FormLabel>
                  <TextField
                    id="contactDate1"
                    name="contactDate1"
                    type='date'
                    size='small'
                    fullWidth
                    value={formik.values.contactDate1}
                    onChange={formik.handleChange}
                  />
                </Grid>
                <Grid item xs={12} sm={4} md={4}>
                  <FormLabel>Contact Type 1</FormLabel>
                  <TextField
                    id="contactType1"
                    name="contactType1"
                    label=""
                    size='small'
                    fullWidth
                    value={formik.values.contactType1}
                    onChange={formik.handleChange}
                  />
                </Grid>
                <Grid item xs={12} sm={4} md={4}>
                  <FormLabel>Contact Results 1</FormLabel>
                  <TextField
                    id="contactResults1"
                    name="contactResults1"
                    label=""
                    size='small'
                    fullWidth
                    value={formik.values.contactResults1}
                    onChange={formik.handleChange}
                  />
                </Grid>
                <Grid item xs={12} sm={4} md={4}>
                  <FormLabel>Contact Date 2</FormLabel>
                  <TextField
                    id="contactDate2"
                    name="contactDate2"
                    type='date'
                    size='small'
                    fullWidth
                    value={formik.values.contactDate2}
                    onChange={formik.handleChange}
                  />
                </Grid>
                <Grid item xs={12} sm={4} md={4}>
                  <FormLabel>Contact Type 2</FormLabel>
                  <TextField
                    id="contactType2"
                    name="contactType2"
                    label=""
                    size='small'
                    fullWidth
                    value={formik.values.contactType2}
                    onChange={formik.handleChange}
                  />
                </Grid>
                <Grid item xs={12} sm={4} md={4}>
                  <FormLabel>Contact Results 2</FormLabel>
                  <TextField
                    id="contactResults2"
                    name="contactResults2"
                    label=""
                    size='small'
                    fullWidth
                    value={formik.values.contactResults2}
                    onChange={formik.handleChange}
                  />
                </Grid>
                <Grid item xs={12} sm={4} md={4}>
                  <FormLabel>Contact Date 3</FormLabel>
                  <TextField
                    id="contactDate3"
                    name="contactDate3"
                    type='date'
                    size='small'
                    fullWidth
                    value={formik.values.contactDate3}
                    onChange={formik.handleChange}
                  />
                </Grid>
                <Grid item xs={12} sm={4} md={4}>
                  <FormLabel>Contact Type 3</FormLabel>
                  <TextField
                    id="contactType3"
                    name="contactType3"
                    label=""
                    size='small'
                    fullWidth
                    value={formik.values.contactType3}
                    onChange={formik.handleChange}
                  />
                </Grid>
                <Grid item xs={12} sm={4} md={4}>
                  <FormLabel>Contact Results 3</FormLabel>
                  <TextField
                    id="contactResults3"
                    name="contactResults3"
                    label=""
                    size='small'
                    fullWidth
                    value={formik.values.contactResults3}
                    onChange={formik.handleChange}
                  />
                </Grid>
                <Grid item xs={12} sm={4} md={4}>
                  <FormLabel>Pre-Approved?</FormLabel>
                  <TextField
                    id="preApproved"
                    name="preApproved"
                    label=""
                    size='small'
                    fullWidth
                    value={formik.values.preApproved}
                    onChange={formik.handleChange}
                  />
                </Grid>
                <Grid item xs={12} sm={4} md={4}>
                  <FormLabel>Refi Offer Accepted?</FormLabel>
                  <TextField
                    id="refiOfferAccepted"
                    name="refiOfferAccepted"
                    label=""
                    size='small'
                    fullWidth
                    value={formik.values.refiOfferAccepted}
                    onChange={formik.handleChange}
                  />
                </Grid>
                <Grid item xs={12} sm={4} md={4}>
                  <FormLabel>Assign Campaign</FormLabel>
                  <TextField
                    id="assignCampaign"
                    name="assignCampaign"
                    label=""
                    size='small'
                    fullWidth
                    value={formik.values.assignCampaign}
                    onChange={formik.handleChange}
                  />
                </Grid>
                <Grid item xs={12} sm={4} md={4}>
                  <FormLabel>Campaign Last Sent Date</FormLabel>
                  <TextField
                    id="campaignLastSentDate"
                    name="campaignLastSentDate"
                    type='date'
                    size='small'
                    fullWidth
                    value={formik.values.campaignLastSentDate}
                    onChange={formik.handleChange}
                  />
                </Grid>
                <Grid item xs={12} sm={4} md={4}>
                  <FormLabel>Opt-In?</FormLabel>
                  <TextField
                    id="optIn"
                    name="optIn"
                    label=""
                    size='small'
                    fullWidth
                    value={formik.values.optIn}
                    onChange={formik.handleChange}
                  />
                </Grid>
                <Grid item xs={12} sm={4} md={4}>
                  <FormLabel>Subscribed?</FormLabel>
                  <TextField
                    id="subscribed"
                    name="subscribed"
                    label=""
                    size='small'
                    fullWidth
                    value={formik.values.subscribed}
                    onChange={formik.handleChange}
                  />
                </Grid>
                <Grid item xs={12}>
                  <FormLabel>Helpful Information</FormLabel>
                  <TextField
                    id="helpfulInfo"
                    name="helpfulInfo"
                    label=""
                    size='small'
                    multiline
                    rows={4}
                    fullWidth
                    value={formik.values.helpfulInfo}
                    onChange={formik.handleChange}
                  />
                </Grid>
              </Grid>
            </DialogContentText>
          </form>
        </DialogContent>
        <DialogActions>
          <Button onClick={formik.handleSubmit} variant='contained' color='primary'>Save</Button>
          <Button onClick={() => {
            formik.resetForm();
            handleClose();
          }} variant='outlined' color='error'>Cancel</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default Add;
